var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("证件资料")))]), _vm.type == 1 ? _c("div", {
    staticStyle: {
      "margin-right": "100px"
    },
    attrs: {
      slot: "btn"
    },
    slot: "btn"
  }, [_vm.isAuth("home.companyWorkersZip") ? _c("a-button", {
    on: {
      click: _vm.downloadFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下载") + _vm.$t("证件资料")))]) : _vm._e()], 1) : _vm._e()]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("身份证正面"),
      prop: "idCardFront"
    }
  }, [_c("div", {
    style: _vm.type == 1 ? "display:flex;align-items: end;" : ""
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.idCardFrontObj,
      accept: "image/*,.pdf",
      "list-type": "picture",
      data: {
        module: "certificate"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: _vm.type == 1 ? false : true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.handleChange,
      preview: _vm.handlePreview
    }
  }, [_vm.type != 1 && _vm.idCardFrontObj.length < 1 ? _c("a-button", [_vm._v(_vm._s(_vm.$t("选择文件")))]) : _vm._e()], 1), _vm.type == 1 && _vm.idCardFrontObj.length != 0 ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.downloadFun2(_vm.idCardFrontObj[0]);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("下载")))]) : _vm._e()], 1), !_vm.disabled ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("仅支持上传jpg，pdf，png，jpeg，bmp格式文件，最大不超10M")))]) : _vm._e()]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("身份证反面"),
      prop: "idCardBack"
    }
  }, [_c("div", {
    style: _vm.type == 1 ? "display:flex;align-items: end;" : ""
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.idCardBackObj,
      accept: "image/*,.pdf",
      "list-type": "picture",
      data: {
        module: "certificate"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: _vm.type == 1 ? false : true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.idCardBackChange,
      preview: _vm.handlePreview
    }
  }, [_vm.type != 1 && _vm.idCardBackObj.length < 1 ? _c("a-button", [_vm._v(_vm._s(_vm.$t("选择文件")))]) : _vm._e()], 1), _vm.type == 1 && _vm.idCardBackObj.length != 0 ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.downloadFun2(_vm.idCardBackObj[0]);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("下载")))]) : _vm._e()], 1), !_vm.disabled ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("仅支持上传jpg，pdf，png，jpeg，bmp格式文件，最大不超10M")))]) : _vm._e()]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("学历照片"),
      prop: "diploma"
    }
  }, [_c("div", {
    style: _vm.type == 1 ? "display:flex;align-items: end;" : ""
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.diplomaObj,
      accept: "image/*,.pdf",
      "list-type": "picture",
      data: {
        module: "certificate"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: _vm.type == 1 ? false : true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.diplomaChange,
      preview: _vm.handlePreview
    }
  }, [_vm.type != 1 && _vm.diplomaObj.length < 1 ? _c("a-button", [_vm._v(_vm._s(_vm.$t("选择文件")))]) : _vm._e()], 1), _vm.type == 1 && _vm.diplomaObj.length != 0 ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.downloadFun2(_vm.diplomaObj[0]);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("下载")))]) : _vm._e()], 1), !_vm.disabled ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("仅支持上传jpg，pdf，png，jpeg，bmp格式文件，最大不超10M")))]) : _vm._e()]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("银行卡正面"),
      prop: "bankCard"
    }
  }, [_c("div", {
    style: _vm.type == 1 ? "display:flex;align-items: end;" : ""
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.bankCardObj,
      accept: "image/*,.pdf",
      "list-type": "picture",
      data: {
        module: "certificate"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: _vm.type == 1 ? false : true,
        showDownloadIcon: _vm.type == 1 ? true : false
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.bankCardChange,
      preview: _vm.handlePreview,
      download: _vm.downloadFun2
    }
  }, [_vm.type != 1 && _vm.bankCardObj.length < 1 ? _c("a-button", [_vm._v(_vm._s(_vm.$t("选择文件")))]) : _vm._e()], 1)], 1), !_vm.disabled ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("仅支持上传jpg，pdf，png，jpeg，bmp格式文件，最大不超10M")))]) : _vm._e()]), _vm.disabled && _vm.laborContractObj.length != 0 || !_vm.disabled ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("劳动合同")
    }
  }, [_c("div", {
    style: _vm.type == 1 ? "display:flex;align-items: end;" : ""
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.laborContractObj,
      accept: "image/*,.pdf",
      "list-type": "picture",
      data: {
        module: "certificate"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: _vm.type == 1 ? false : true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.laborContractChange,
      preview: _vm.handlePreview
    }
  }, [_vm.type != 1 && _vm.laborContractObj.length < 1 ? _c("a-button", [_vm._v(_vm._s(_vm.$t("选择文件")))]) : _vm._e()], 1), _vm.type == 1 && _vm.laborContractObj.length != 0 ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.downloadFun2(_vm.laborContractObj[0]);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("下载")))]) : _vm._e()], 1), !_vm.disabled ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("仅支持上传jpg，pdf，png，jpeg，bmp格式文件，最大不超10M")))]) : _vm._e()]) : _vm._e()], 1), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      width: 800
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      alt: "example",
      src: _vm.previewImage
    }
  })]), _vm.type != 1 ? _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("prev");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _vm.type != 1 ? _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))]) : _vm._e()], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };